import EventTarget from "./event-target";

const EVENTS = {
    VISIBLE: "VISIBLE",
    INVISIBLE: "INVISIBLE"
};
const BROWSER_VISIBILITY_MAP = {
    "hidden": "visibilitychange",
    "webkitHidden": "webkitvisibilitychange",
    "mozHidden": "mozvisibilitychange",
    "msHidden": "msvisibilitychange"
};

let isHiddenAttrName;
let visibilityChangeEventName;
let isVisibilityAPISupported = false;

for (const key in BROWSER_VISIBILITY_MAP) {
    if (typeof document[key] !== "undefined") {
        isHiddenAttrName = key;
        visibilityChangeEventName = BROWSER_VISIBILITY_MAP[key];
        isVisibilityAPISupported = true;
        break;
    }
}

class VisibilityMonitor extends EventTarget {
    constructor() {
        super();

        if (VisibilityMonitor._isVisibilityAPISupported()) {
            this._onVisibilityChange = this._onVisibilityChange.bind(this);
            document.addEventListener(visibilityChangeEventName, this._onVisibilityChange);
        }
    }

    dispose() {
        if (VisibilityMonitor._isVisibilityAPISupported()) {
            document.removeEventListener(visibilityChangeEventName, this._onVisibilityChange);
        }
        super.dispose();
    }

    /**
     * @private
     */
    _onVisibilityChange() {
        const eventName = VisibilityMonitor.isPageVisible() ? EVENTS.VISIBLE : EVENTS.INVISIBLE;
        this.trigger(eventName);
    }

    static isPageVisible() {
        return !document[isHiddenAttrName];
    }

    /**
     * @private
     * @returns {boolean}
     */
    static _isVisibilityAPISupported() {
        return isVisibilityAPISupported;
    }
}

export { EVENTS };
export default VisibilityMonitor;
